<div class="header">
	<div *ngIf="showInfoIcon" class="icon">
		<img src="assets/img/icons/icon-info-purple.svg" alt="info" />
	</div>
	<div class="info">
		<div class="title" [innerHtml]="title"></div>
	</div>
</div>
<div class="features">
	<ul *ngIf="features && features.length > 0">
		<li *ngFor="let feature of features">
			<img src="/assets/img/icons/icon-tick-orange.svg" alt="" />
			<span [innerHtml]="feature"></span>
		</li>
	</ul>
</div>
<div class="footer">
	<p *ngFor="let note of footnote" [innerHtml]="note"></p>
</div>
